import { forwardRef, type InputHTMLAttributes } from 'react';

interface DsInputProps extends InputHTMLAttributes<HTMLInputElement> {
  /**
   * Render the typed text in `var(--font-mono)`. Reserve for code-style
   * fields — cron expressions, regexes, JSONPath, XML tags, currency codes,
   * short identifiers. Prose fields (names, descriptions, URLs, emails) should
   * stay on the default UI font.
   */
  mono?: boolean;
}

export const DsInput = forwardRef<HTMLInputElement, DsInputProps>(
  ({ className = '', mono = false, ...props }, ref) => {
    const cls = ['ds-input', mono && 'is-mono', className].filter(Boolean).join(' ');
    return <input ref={ref} className={cls} {...props} />;
  },
);
